import styled from '@emotion/styled';
import { Grid } from '@material-ui/core';

const ButtonGrid = styled(Grid)`
  margin: 16px 0px;
  display: flex;
  justify-content: flex-end;
`;

export default ButtonGrid;
